import { render, staticRenderFns } from "./vsSidebar.vue?vue&type=template&id=aeaf1ea2"
import script from "./vsSidebar.vue?vue&type=script&lang=js"
export * from "./vsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports